import RankingStatCaseVerifier from "../../validators/RankingStatCaseVerifier.js";
import ResultsSlice from "../../valueObjects/ResultsSlice.js";

class RankingStatCalculatorBase {
    constructor(
        supportedParams, rankingStatCaseVerifier
    ) {
        if (!(rankingStatCaseVerifier instanceof RankingStatCaseVerifier)) {
            throw new TypeError('rankingStatCaseVerifier must be an instance inheriting from RankingStatCaseVerifier class');
        }
        this.rankingStatCaseVerifier = rankingStatCaseVerifier;

        if (!(supportedParams instanceof Array)) {
            throw new TypeError('supportedParams must be an array');
        }
        if (!supportedParams.length) {
            throw new Error('supportedParams must contain at least one parameter');
        }

        this.supportedParams = [];
        for (let p = 0; p < supportedParams.length; p++) {
            this.addParameter(supportedParams[p]);
        }
    }

    addParameter(parameter) {
        if (!this.isParameterValid(parameter)) {
            throw new TypeError('parameter must be an object with key and aggregator properties');
        }

        this.supportedParams.push(parameter);
    }

    isParameterValid(parameter) {
        return typeof(parameter) === 'object'
            && parameter.hasOwnProperty('key')
            && parameter.hasOwnProperty('aggregator')
        ;
    }

    canCalculate(parameter, slice, session, league) {
        if (!this.isParameterValid(parameter)) {
            throw new TypeError('parameter must be an object containing key and aggregator properties');
        }

        return this.supportedParams.some(p => p === parameter || p.key === parameter.key)
            && this.rankingStatCaseVerifier.situationMatches(session, league, slice);
        ;
    }

    calculate(parameter, slice, session, league) {
        if (!this.isParameterValid(parameter)) {
            throw new TypeError('parameter is not supported');
        }
        if (!(slice instanceof ResultsSlice)) {
            throw new TypeError('slice must be an instance inheriting from ResultsSlice class');
        }

        return this.calculateStat(parameter, slice, session, league);
    }

    /**
     * Calculates given statistical parameter
     * @param {object} parameter - a parameter to calculate, object from Enum PitchingRankingStats, BattingRankingStats or GeneralRankingStats
     * @param {ResultsSlice} slice - result slice with scope
     * @param {object} session - session object, @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/session-v2.json
     * @param {object} league - league object, @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/league.json
     * @returns {RankingStat|null} RankingStat instance or null when calculation wasn't possible
     */
    calculateStat(parameter, slice, session, league) {
        throw new Error('calculate not implemented');
    }
}

export default RankingStatCalculatorBase;